import React from 'react';
import { Box, Typography } from '@mui/material';
import OvertimeRateSetup from '../components/PayRoll/OvertimeRateSetup';

export default function PayrollPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }} className="page-title">
        Payroll Management
      </Typography>
      <div className="bg-white rounded-xl shadow p-6">
        <Typography variant="body1" sx={{ mb: 2 }}>
          Welcome to the new Payroll Module.
        </Typography>
        {/* Render imported components to establish integration */}
        <OvertimeRateSetup />
      </div>
    </Box>
  );
}
